import script from "./ButtonMedium.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonMedium.vue?vue&type=script&setup=true&lang=js"

import "./ButtonMedium.vue?vue&type=style&index=0&id=602e930a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602e930a"]])

export default __exports__